import {GET, POST} from '../index'

// 商品列表
export const goodsList = (data) => {
  return GET('/goods/list', data)
}

// 改变指定状态
export const goodsChangeStatus = (data) => {
  return POST('/goods/change/status', data)
}

// 删除商品
export const delGoods = (data) => {
  return POST('/goods/del', data)
}

// 获取所有游戏
export const games = (data) => {
  return GET('/goods/games', data)
}

// 添加商品
export const addGoods = (data) => {
  return POST('/goods/add', data)
}

// 获取商品信息
export const getInfo = (data) => {
  return GET('/goods/info', data)
}

// 编辑商品
export const editGoods = (data) => {
  return POST('/goods/edit', data)
}



// WEBPACK FOOTER //
// ./src/api/goods/index.js